import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';

const roleHome = {
  user: '/user/dashboard', checker: '/checker/dashboard',
  approver: '/approver/dashboard', it_support: '/it/dashboard', admin: '/admin/dashboard',
};

const SsoCallback = () => {
  const [params] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const error = params.get('error');

    if (error || !token) {
      toast.error('Microsoft login failed. Please try again.');
      navigate('/login');
      return;
    }

    try {
      const user = jwtDecode(token);
      login(token, user);
      navigate(roleHome[user.role] || '/user/dashboard');
    } catch {
      toast.error('Invalid session. Please try again.');
      navigate('/login');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg,#060d3a,#0d1a6e)' }}>
      <div style={{ color: '#fff', fontSize: 16, fontWeight: 600 }}>Signing you in…</div>
    </div>
  );
};

export default SsoCallback;
